<template>
    <v-chip outlined :small="small" :dark="chipAttribute.dark" :color="chipAttribute.color">{{ chipAttribute.text }}</v-chip>
</template>

<script>
export default {
    props: {
        status: {
            type: String,
            required: true
        },
        small: {
            type: Boolean,
            default: () => false
        }
    },
    data: () => ({
        chipAttributes : {
            paid: {
                color: 'green',
                dark: true,
                text: 'Paid'
            },
            open: {
                color: 'orange',
                dark: true,
                text: 'Open'
            },
            cancel: {
                color: 'red lighten-3',
                dark: true,
                text: 'Cancel'
            }
        }
    }),
    computed: {
        chipAttribute () {
            return this.chipAttributes[this.status] ? this.chipAttributes[this.status] : {
                color: 'grey lighten-5',
                dark: false,
                text: this.status
            }
        }
    }
}
</script>

<style>

</style>